var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 548.3 530.5",
    style: {
      enableBackground: "new 0 0 548.3 530.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.3,263L518.1,56.2c4.7-4.7,7.3-11,7.3-17.7c0-6.7-2.6-13-7.3-17.7c-4.7-4.7-11-7.3-17.7-7.3s-13,2.6-17.7,7.3 L275.9,227.6L69,20.7c-9.8-9.8-25.7-9.8-35.4,0c-4.7,4.7-7.3,11-7.3,17.7c0,6.7,2.6,13,7.3,17.7L240.4,263L33.6,469.8 c-4.7,4.7-7.3,11-7.3,17.7c0,6.7,2.6,13,7.3,17.7c9.8,9.8,25.7,9.8,35.4,0l206.8-206.8l206.8,206.8c4.7,4.7,11,7.3,17.7,7.3 c6.7,0,13-2.6,17.7-7.3c4.7-4.7,7.3-11,7.3-17.7s-2.6-13-7.3-17.7L311.3,263z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseBlack);
export default __webpack_public_path__ + "static/media/close-black.807f7653117f605015083a76fec762e7.svg";
export { ForwardRef as ReactComponent };